import React, { useEffect, useRef, useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Input,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { MDBDataTable } from "mdbreact";
import { Link } from "react-router-dom";
import { formatDob, formatMobile } from "helpers/dob_helper";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import { connect } from "react-redux";
import * as url from "../../helpers/url_helper";
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import { setBreadcrumbItems } from "../../store/actions";
import { toast } from "react-toastify";
import Pagination from "./Pagination";

const UserList = (props) => {
  document.title = "Manage Users - VUF";
  const [userdataList, setUserDataList] = useState([]);
  const [DateRange, setDateRange] = useState({});

  const [SelectUser, setSelectUser] = useState({});
  const [selectionRange, setSelectionRange] = useState({});

  const [SelectCategory, setSelectCategory] = useState({});
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");

  const [SelectDesignation, setSelectDesignation] = useState({});
  const [designationOptions, setDesignationOptions] = useState([]);
  const [selectedDesignation, setSelectedDesignation] = useState("");

  const [SelectDepartment, setSelectDepartment] = useState({});
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [countries, setCountries] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [cityList, setCityList] = useState([]);

  const [selectedCity, setSelectedCity] = useState({});
  const [selectedCountry, setSelectedCountry] = useState({});
  const [selectedDistrict, setSelectedDistrict] = useState({});
  const [selectedState, setSelectedState] = useState({});

  const [districtCode, setDistrictCode] = useState({});
  const [stateCode, setStateCode] = useState({});
  const [countryDataCode, setCountryDataCode] = useState({});
  const [exportType, setExportType] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [MobileNo, setMobileno] = useState("");
  const [VUFId, setVufId] = useState("");
  const [limit, setLimit] = useState(10);
  const [rows, setRows] = useState([]);

  const [isLoading, setLoading] = useState(false);
  const breadcrumbItems = [
    { title: "VUF", link: "#" },
    { title: "User List", link: "#" },
  ];
  const UserType = [
    {
      options: [
        { label: "VUF Main App", value: "VUFAPP" },
        { label: "VBN App", value: "VUFGBN" },
        { label: "VUF Sangathan", value: "SANGATHAN_BETA" },
      ],
    },
  ];

  useEffect(() => {
    props.setBreadcrumbItems("User List", breadcrumbItems);
  });

  const flatpickrRef = useRef(null);

  const hasActiveValue = (value) => {
    if (value === undefined || value === null) return false;
    if (typeof value === "string") return value.trim() !== "";
    if (typeof value === "object") {
      if ("value" in value) {
        return value.value !== "" && value.value !== undefined && value.value !== null;
      }
      if ("label" in value) {
        return value.label !== "" && value.label !== "--Select--";
      }
      return Object.keys(value).length > 0;
    }
    return Boolean(value);
  };

  const handleSearch = () => {
    setPage(1);
    getUsers(
      false,
      SelectUser.value,
      selectionRange.startDate,
      selectionRange.endDate,
      selectedCountry,
      selectedState,
      selectedDistrict,
      selectedCity,
      "",
      "",
      "",
      MobileNo,
      searchText,
      1,
    );
  };

  const handleReset = () => {
    // 1. Reset all UI states
    setSearchText("");
    setSelectedCountry("");
    setSelectedState("");
    setSelectedDistrict("");
    setSelectedCity("");
    setSelectUser({ label: "VUF Main App", value: "" }); // Ensure value is reset too

    if (flatpickrRef.current?.flatpickr) {
      flatpickrRef.current.flatpickr.clear();
      setSelectionRange([]);
      dateval([]);
    }

    // 2. TRIGGER THE API IMMEDIATELY with empty values
    // Don't wait for state to update; pass "" or null directly
    setPage(1);
    getUsers(
      false, // applyDateFilter = false
      "", // Reset user type
      null, // Start date
      null, // End date
      "", // Country
      "", // State
      "", // District
      "", // City
      "",
      "",
      "",
      "", // Other placeholders
      "", // Search Text
      1,
    );
  };
  const handlePageChange = (newPage) => {
    if (newPage < 1 || newPage > totalPages) {
      return;
    }

    setPage(newPage);

    getUsers(
      false,
      SelectUser?.value || "",
      selectionRange.startDate,
      selectionRange.endDate,
      selectedCountry,
      selectedState,
      selectedDistrict,
      selectedCity,
      SelectCategory,
      SelectDesignation,
      SelectDepartment,
      MobileNo,
      searchText,
      newPage,
    );
  };
  function getUsers(
    loading,
    UserType,
    startDate,
    endDate,
    Country,
    state,
    district,
    city,
    SelectCategory,
    SelectDesignation,
    SelectDepartment,
    mobileNo,
    searchText,
    currentPage = page, // Default value current state ni rakho
  ) {
    setLoading(true);
    const isDesignationFilter =
      hasActiveValue(SelectCategory) ||
      hasActiveValue(SelectDesignation) ||
      hasActiveValue(SelectDepartment);
    const isAppManagerFilter =
      Boolean(startDate && endDate) ||
      hasActiveValue(Country) ||
      hasActiveValue(state) ||
      hasActiveValue(district) ||
      hasActiveValue(city) ||
      hasActiveValue(mobileNo) ||
      hasActiveValue(searchText);

    const applyDateFilter = isDesignationFilter || isAppManagerFilter;
    const queryParams = exportType ? "" : `?page=${currentPage}&limit=${limit}`;
    let urlPath = `${url.VUF_APP_API}appmanager/appusers${queryParams}`;

    if (isDesignationFilter) {
      urlPath = `${url.AUTH_URL}getUsersByDesignation${queryParams}`;
    }

    fetch(urlPath, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        filter: applyDateFilter,
        UserType: UserType,
        country:
          Country?.label == "" || Country?.label == "--Select--"
            ? ""
            : Country?.label || "",
        city:
          city?.label == "" || city?.label == "--Select--"
            ? ""
            : city?.label || "",
        state:
          state?.label == "" || state?.label == "--Select--"
            ? ""
            : state?.label || "",
        district:
          district?.label == "" || district?.label == "--Select--"
            ? ""
            : district?.label || "",
        startDate,
        endDate,
        village: "",
        categoryId: SelectCategory?.value || "",
        designationId: SelectDesignation?.value || "",
        departmentId: SelectDepartment?.value || "",
        mobileNo: mobileNo || "",
        searchText: searchText || "",
      }),
    })
      .then((response) => response.json())
      .then((responseData) => {
        setLoading(false);
        if (responseData.status && responseData.data != undefined) {
          var List = responseData.data;
          var pagination = responseData.pagination || {};
          const parsedTotalRecords = Number(pagination.totalRecords || 0);
          const parsedTotalPages = Number(pagination.totalPages || 0);
          const calculatedPages = Math.max(
            1,
            Math.ceil(parsedTotalRecords / limit),
          );
          const resolvedTotalPages =
            parsedTotalPages > 0 ? parsedTotalPages : calculatedPages;

          setTotalRecords(parsedTotalRecords);
          setTotalPages(resolvedTotalPages);
          const userList = List.map((user) => {
            if (user.userid !== undefined) {
              const userInfo = user.userid || {};
              const createdAt = new Date(userInfo.createdAt);
              return {
                _id: userInfo._id,
                vufId: userInfo.vufId,
                firstName: userInfo.firstName,
                lastName: userInfo.lastName,
                email: userInfo.email,
                nickname: userInfo.nickname,
                mobileNo: userInfo.mobileNo,
                profession: userInfo.profession,
                otherProfession: userInfo.otherProfession,
                Address: userInfo.street_address,
                country: userInfo.country,
                state: userInfo.state,
                district: userInfo.district,
                city: userInfo.city,
                village: userInfo.village,
                area: userInfo.area,
                dob: userInfo.dob,
                age: userInfo.age,
                date: createdAt
                  .toLocaleDateString("en-IN", {
                    timeZone: "Asia/Kolkata",
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                  })
                  .replace(/\//g, "-"),
                time: createdAt.toLocaleTimeString("en-IN", {
                  timeZone: "Asia/Kolkata",
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true,
                }),
              };
            } else {
              const createdAt = new Date(user.createdAt);
              return {
                _id: user._id,
                vufId: user.vufId,
                firstName: user.firstName,
                lastName: user.lastName,
                email: user.email,
                nickname: user.nickname,
                mobileNo: user.mobileNo,
                profession: user.profession,
                otherProfession: user.otherProfession,
                Address: user.street_address,
                country: user.country,
                state: user.state,
                district: user.district,
                city: user.city,
                village: user.village,
                area: user.area,
                dob: user.dob,
                age: user.age,
                date: createdAt
                  .toLocaleDateString("en-IN", {
                    timeZone: "Asia/Kolkata",
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                  })
                  .replace(/\//g, "-"),
                time: createdAt.toLocaleTimeString("en-IN", {
                  timeZone: "Asia/Kolkata",
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true,
                }),
              };
            }
          });
          setRows(userList);
          setUserDataList(userList);
          if (SelectCategory?.value) {
            onGetDesignationList(SelectCategory?.value);
            onGetDepartmentList(SelectCategory?.value);
          }
          if (Country == "" && city == "" && state == "" && district == "") {
            onGetCountryList();
          }
        } else {
          setUserDataList([]);
          setTotalRecords(0);
          setTotalPages(1);
          //onGetCategoryList();
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        setLoading(false);
        //toast.error("Something went wrong, Please try again after sometime.");
      });
  }

  async function onGetCountryList() {
    try {
      const urlPath = "auth/CountryList";

      const response = await fetch(url.VUF_APP_API + urlPath, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      const responseData = await response.json();

      if (!responseData?.status) return;

      const data = responseData.response || [];

      // Base country list
      let countries = [
        { label: "--Select--", value: "" },
        ...data.map((c) => ({
          label: c.country_name,
          value: c.id,
        })),
      ];

      // If userdataList exists, filter countries
      if (userdataList?.length > 0) {
        const uniqueCountries = [
          ...new Set(userdataList.map((u) => u.country).filter(Boolean)),
        ];

        countries = countries.filter(
          (c) => c.value === "" || uniqueCountries.includes(c.label),
        );
      }

      // Set dropdown options
      setCountries([{ options: countries }]);

      // Reset dependent dropdowns
      setSelectedCity("");
      setSelectedDistrict("");
      setSelectedState("");
    } catch (error) {
      console.error("Country list error:", error);
    }
  }

  function onGetCategoryList() {
    let urlPath = "getCategory";

    fetch(url.AUTH_URL + urlPath, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((responseData) => {
        if (responseData.status) {
          var data = responseData.data;

          let category = [];
          category.push({ label: "--Select--", value: "" });
          category.push({ label: "All", value: "All" });

          data.map((c) => {
            category.push({ label: c.name, value: c._id });
          });

          const cate = [{ options: category }];
          setCategoryOptions(cate);
        }
      })
      .catch((error) => {
        console.log(error);

        console.error("Fetch error:", error);
      })
      .finally(() => {
        // Optional cleanup
      });
  }
  function onGetDepartmentList(id) {
    let urlPath = "getDepartment/" + id;

    fetch(url.AUTH_URL + urlPath, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json()) // parse JSON here
      .then((responseData) => {
        if (responseData.status) {
          var data = responseData.data;

          let department = [];
          department.push({ label: "--Select--", value: "" });
          department.push({ label: "All", value: "All" });

          data.map((d) => {
            department.push({ label: d.name, value: d._id });
          });

          const departments = [{ options: department }];
          setDepartmentOptions(departments);
        }
      })
      .catch((error) => {
        console.log(error);

        console.error("Fetch error:", error);
      })
      .finally(() => {
        // Optional cleanup
      });
  }
  function onGetDesignationList(id) {
    let urlPath = "getDesignation/" + id;

    fetch(url.AUTH_URL + urlPath, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json()) // parse JSON here
      .then((responseData) => {
        if (responseData.status) {
          var data = responseData.data;

          let designation = [];
          designation.push({ label: "--Select--", value: "" });
          designation.push({ label: "All", value: "All" });
          data.map((post) => {
            designation.push({ label: post.name, value: post._id });
          });

          const designations = [{ options: designation }];
          setDesignationOptions(designations);
          setCategoryOptions([]);
        }
      })
      .catch((error) => {
        console.log(error);
        console.error("Fetch error:", error);
      })
      .finally(() => {
        // Optional cleanup
      });
  }
  const getPageNumbers = () => {
    const maxPages = 4;
    let start = Math.max(page - 1, 1);
    let end = Math.min(start + maxPages - 1, totalPages);

    if (end - start < maxPages - 1) {
      start = Math.max(end - maxPages + 1, 1);
    }

    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  };
  useEffect(() => {
    setSelectUser({ label: "VUF Main App", value: "VUFAPP" });
    getUsers(
      true,
      "VUFAPP",
      selectionRange.startDate,
      selectionRange.endDate,
      selectedCountry,
      selectedState,
      selectedDistrict,
      selectedCity,
      "",
      "",
      "",
      MobileNo,
      searchText,
      1,
    );
    onGetCountryList();
    onGetCategoryList();
  }, []);

  async function onGetStateList(countryId) {
    setCountryDataCode(countryId);

    if (!countryId) {
      setStateList([{ options: [{ label: "--Select--", value: "" }] }]);
      return;
    }

    try {
      setLoading(true);

      const urlPath = `auth/StatesList/${countryId}`;

      const response = await fetch(url.VUF_APP_API + urlPath, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      const responseData = await response.json();

      if (!responseData?.status) return;

      const data = responseData.response || [];

      const stateList = [
        { label: "--Select--", value: "" },
        ...data.map((s) => ({
          label: s.state_title,
          value: s.state_id,
        })),
      ];

      setStateList([{ options: stateList }]);

      // Reset dependent dropdowns
      setSelectedDistrict("");
      setSelectedCity("");
    } catch (error) {
      console.error("State list error:", error);
    } finally {
      setLoading(false);
    }
  }

  async function onGetDistrictList(stateId) {
    setStateCode(stateId);

    if (!stateId) {
      setDistrictList([{ options: [{ label: "--Select--", value: "" }] }]);
      return;
    }

    try {
      setLoading(true);

      const urlPath = `auth/DistrictsList/${stateId}`;

      const response = await fetch(url.VUF_APP_API + urlPath, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      const responseData = await response.json();

      if (!responseData?.status) return;

      const data = responseData.response || [];

      const districtList = [
        { label: "--Select--", value: "" },
        ...data.map((d) => ({
          label: d.district_title,
          value: d.districtid,
        })),
      ];

      setDistrictList([{ options: districtList }]);

      // Reset city dropdown
      setSelectedCity("");
    } catch (error) {
      console.error("District list error:", error);
    } finally {
      setLoading(false);
    }
  }

  async function onGetCitiesList(districtId) {
    setDistrictCode(districtId);

    if (!districtId) {
      setCityList([{ options: [{ label: "--Select--", value: "" }] }]);
      return;
    }

    try {
      const urlPath = `auth/CitiesList/${districtId}`;

      const response = await fetch(url.VUF_APP_API + urlPath, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      const responseData = await response.json();

      if (!responseData?.status) return;

      const data = responseData.response || [];

      let cityList = [
        { label: "--Select--", value: "" },
        ...data.map((c) => ({
          label: c.name,
          value: c.id,
        })),
      ];

      // Filter cities based on userdataList (same logic, cleaner)
      if (!selectedCity && userdataList?.length > 0) {
        const uniqueCities = [
          ...new Set(userdataList.map((u) => u.city).filter(Boolean)),
        ];

        cityList = cityList.filter(
          (c) => c.value === "" || uniqueCities.includes(c.label),
        );
      }

      setCityList([{ options: cityList }]);
    } catch (error) {
      console.error("City list error:", error);
    }
  }

  function exportToExcel(data, type) {
    var fileName = "UserList";
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, `${fileName}.xlsx`);
  }

  function dateval(val) {
    setDateRange(val);
    if (val.length === 2) {
      setSelectionRange({ startDate: val[0], endDate: val[1] });
      getUsers(
        true,
        SelectUser.value,
        val[0],
        val[1],
        selectedCountry,
        selectedState,
        selectedDistrict,
        selectedCity,
        SelectCategory,
        SelectDesignation,
        SelectDepartment,
        MobileNo,
        searchText,
      );
    } else if (val.length == 0) {
      getUsers(
        false,
        SelectUser.value,
        selectionRange.startDate,
        selectionRange.endDate,
        selectedCountry,
        selectedState,
        selectedDistrict,
        selectedCity,
        SelectCategory,
        SelectDesignation,
        SelectDepartment,
        MobileNo,
        searchText,
      );
    }
  }

  const formattedEventList = userdataList.map((user) => ({
    ...user,
    firstName: user.firstName + " " + user.lastName,
    email: user.email || "---",
    mobileNo: formatMobile(user.countryCode, user.mobileNo) || "---",
    dob: formatDob(user.dob),
    VUFID: user.vufId ? user.vufId : "---",
    Address:
      user.Address == undefined ||
      ((user.city != null && user.city !== undefined && user.city != "") ||
      (user.district != null &&
        user.district !== undefined &&
        user.district != "") ||
      (user.state != null && user.state !== undefined && user.state != "") ||
      (user.country != null && user.country !== undefined && user.country != "")
        ? user?.city +
          ", " +
          user?.district +
          ", " +
          user?.state +
          ", " +
          user?.country
        : "") ||
      "---",
    Action: [
      <div className="d-flex justify-content-around">
        <Link
          to={`/UserDetails/Users/${user._id}`}
          className="btn btn-info btn-sm"
        >
          {" "}
          <span className="menu-text" style={{ color: "white" }}>
            {" "}
            <span
              className=" menu-icon fas fa fa-eye"
              style={{ color: "white" }}
            >
              {" "}
            </span>
          </span>{" "}
        </Link>
        <Link
          to={`/UserDetailsEdit/Users/${user._id}`}
          className="btn btn-warning btn-sm"
        >
          {" "}
          <span className="menu-text" style={{ color: "white" }}>
            {" "}
            <span
              className="menu-icon fas fa fa-edit"
              style={{ color: "white" }}
            >
              {" "}
            </span>
          </span>{" "}
        </Link>
      </div>,
    ],
  }));
  const tableData = {
    columns: [
      { label: "Name", field: "firstName", width: 150 },
      { label: "Email", field: "email", width: 200 },
      { label: "Mobile no.", field: "mobileNo", width: 150 },
      { label: "DOB", field: "dob", width: 100 },
      { label: "VUF ID", field: "VUFID", width: 120 },
      { label: "Address", field: "Address", width: 250 }, // Address ne vadhare jagya apo
      { label: "Action", field: "Action", width: 100 },
    ],
    rows: formattedEventList,
  };

  return (
    <React.Fragment>
      {isLoading ? (
        <Spinners />
      ) : (
        <Row>
          <Col xl="12">
            <Card>
              <CardHeader>
                <Row className="align-items-center">
                  <Col md="6">
                    <CardTitle className="h4 mb-0">Manage Users</CardTitle>
                  </Col>
                  <Col md="6" className="text-end">
                    <div className="d-flex justify-content-end gap-2">
                      {userdataList.length > 0 && (
                        <button
                          className="btn btn-success"
                          onClick={() => {
                            setExportType(true);
                            exportToExcel(userdataList, "Export");
                          }}
                        >
                          Export to Excel
                        </button>
                      )}

                      <Link
                        to="/create-user"
                        className="btn btn-outline-primary"
                      >
                        <i className="fa fa-plus me-1"></i>
                        New User
                      </Link>
                    </div>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <div className="row">
                  <div className="col-sm-3 form-group">
                    <label>Date Range</label>
                    <Flatpickr
                      className="form-control d-block"
                      placeholder="Select the date range"
                      value={DateRange}
                      onChange={(e) => {
                        setDateRange(e);
                        dateval(e);
                      }}
                      options={{
                        mode: "range",
                        dateFormat: "d-m-Y",
                      }}
                      ref={flatpickrRef}
                    />
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>App Type:</label>
                      <Select
                        classNamePrefix="select2-selection"
                        value={SelectUser}
                        onChange={(e) => {
                          setSelectUser(e);
                          getUsers(
                            false,
                            e.value,
                            selectionRange.startDate,
                            selectionRange.endDate,
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            MobileNo,
                            searchText,
                            1,
                          );
                        }}
                        options={UserType}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Search</label>
                      <Input
                        type="text"
                        className="form-control"
                        placeholder="Enter search keyword"
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Mobile No.</label>
                      <Input
                        type="number"
                        className="form-control"
                        placeholder="Enter Mobile no."
                        value={MobileNo}
                        onChange={(e) => setMobileno(e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Country / દેશ:</label>
                      <Select
                        classNamePrefix="select2-selection"
                        value={selectedCountry}
                        onChange={(e) => {
                          setSelectedCountry(e);
                          setSelectedDistrict({
                            label: "--Select--",
                            value: "",
                          });
                          setSelectedCity({ label: "--Select--", value: "" });
                          setSelectedState({ label: "--Select--", value: "" });
                          getUsers(
                            false,
                            SelectUser.value,
                            selectionRange.startDate,
                            selectionRange.endDate,
                            e,
                            "",
                            "",
                            "",
                            SelectCategory,
                            SelectDesignation,
                            SelectDepartment,
                            MobileNo,
                            searchText,
                            1,
                          );
                          onGetStateList(e.value);
                        }}
                        options={countries}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>State / રાજ્ય:</label>
                      <Select
                        classNamePrefix="select2-selection"
                        value={selectedState}
                        onChange={(e) => {
                          setSelectedState(e);
                          setSelectedDistrict({
                            label: "--Select--",
                            value: "",
                          });
                          setSelectedCity({ label: "--Select--", value: "" });
                          getUsers(
                            false,
                            SelectUser.value,
                            selectionRange.startDate,
                            selectionRange.endDate,
                            selectedCountry,
                            e,
                            "",
                            "",
                            SelectCategory,
                            SelectDesignation,
                            SelectDepartment,
                            MobileNo,
                            searchText,
                            1,
                          );
                          onGetDistrictList(e.value);
                        }}
                        options={stateList}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>District / જિલ્લો:</label>
                      <Select
                        classNamePrefix="select2-selection"
                        value={selectedDistrict}
                        onChange={(e) => {
                          setSelectedDistrict(e);
                          setSelectedCity({ label: "--Select--", value: "" });
                          getUsers(
                            false,
                            SelectUser.value,
                            selectionRange.startDate,
                            selectionRange.endDate,
                            selectedCountry,
                            selectedState,
                            e,
                            "",
                            "",
                            "",
                            "",
                            MobileNo,
                            searchText,
                            1,
                          );
                          onGetCitiesList(e.value);
                        }}
                        options={districtList}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>City / શહેર:</label>
                      <Select
                        classNamePrefix="select2-selection"
                        value={selectedCity}
                        onChange={(e) => {
                          setSelectedCity(e);
                          getUsers(
                            false,
                            SelectUser.value,
                            selectionRange.startDate,
                            selectionRange.endDate,
                            selectedCountry,
                            selectedState,
                            selectedDistrict,
                            e,
                            SelectCategory,
                            SelectDesignation,
                            SelectDepartment,
                            MobileNo,
                            searchText,
                            1,
                          );
                        }}
                        options={cityList}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Category:</label>
                      <Select
                        classNamePrefix="select2-selection"
                        value={SelectCategory}
                        placeholder="Select Search Type"
                        options={categoryOptions}
                        onChange={(e) => {
                          setSelectCategory(e);
                          setMobileno("");
                          setVufId("");

                          getUsers(
                            false,
                            SelectUser.value,
                            selectionRange.startDate,
                            selectionRange.endDate,
                            selectedCountry,
                            selectedState,
                            selectedDistrict,
                            selectedCity,
                            e,
                            "",
                            "",
                            MobileNo,
                            searchText,
                            1,
                          );
                          onGetCategoryList(e.value);
                          onGetDepartmentList(e.value);
                          onGetDesignationList(e.value);
                        }}
                      ></Select>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Designation:</label>
                      <Select
                        classNamePrefix="select2-selection"
                        value={SelectDesignation}
                        onChange={(e) => {
                          setSelectDesignation(e);
                          setSelectedCategory(SelectCategory);
                          setSelectedDesignation(SelectDesignation);
                          onGetCategoryList();
                          getUsers(
                            false,
                            SelectUser.value,
                            selectionRange.startDate,
                            selectionRange.endDate,
                            selectedCountry,
                            selectedState,
                            selectedDistrict,
                            selectedCity,
                            SelectCategory,
                            e,
                            "",
                            MobileNo,
                            searchText,
                            1,
                          );
                        }}
                        options={designationOptions}
                      ></Select>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Department:</label>
                      <Select
                        classNamePrefix="select2-selection"
                        value={SelectDepartment}
                        onChange={(e) => {
                          setSelectDepartment(e);
                          setSelectedCategory(SelectCategory);
                          setSelectedDesignation(SelectDesignation);
                          onGetCategoryList();
                          // onGetDesignationList(SelectDesignation);
                          getUsers(
                            false,
                            SelectUser.value,
                            selectionRange.startDate,
                            selectionRange.endDate,
                            selectedCountry,
                            selectedState,
                            selectedDistrict,
                            selectedCity,
                            SelectCategory,
                            SelectDesignation,
                            e,
                            MobileNo,
                            searchText,
                            1,
                          );
                        }}
                        options={departmentOptions}
                      ></Select>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <form
                      onSubmit={(e) => {
                        e.preventDefault();
                        setPage(1);
                        getUsers(
                          false,
                          SelectUser.value,
                          selectionRange.startDate,
                          selectionRange.endDate,
                          selectedCountry,
                          selectedState,
                          selectedDistrict,
                          selectedCity,
                          "",
                          "",
                          "",
                          MobileNo,
                          searchText,
                          1,
                        );
                      }}
                    >
                      <div className="row">
                        <div className="col-md-3 d-flex mt-4">
                          <button
                            type="button"
                            onClick={handleSearch}
                            className="btn btn-outline-primary me-3"
                          >
                            Search
                          </button>
                          <button
                            className="btn btn-outline-warning"
                            onClick={handleReset}
                          >
                            Reset
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                  <MDBDataTable
                    hover
                    bordered
                    data={tableData}
                    paging={false}
                    searching={false}
                    displayEntries={false}
                    noBottomColumns
                  />
                  <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap gap-2">
                    <div>
                      {`Showing ${totalRecords === 0 ? 0 : (page - 1) * limit + 1} to ${(page - 1) * limit + userdataList.length} of ${totalRecords} entries`}
                    </div>
                    <Pagination
                      page={page}
                      totalPages={totalPages}
                      onPageChange={handlePageChange}
                      getPageNumbers={getPageNumbers}
                    />
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}
    </React.Fragment>
  );
};

export default connect(null, { setBreadcrumbItems })(UserList);
